/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Local_Pickup_No_TrackingInputs */

const en_samples_local_pickup_no_tracking = /** @type {(inputs: Samples_Local_Pickup_No_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Pick Up (No Tracking Required)`)
};

const es_samples_local_pickup_no_tracking = /** @type {(inputs: Samples_Local_Pickup_No_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recogida local (sin rastreo requerido)`)
};

/**
* | output |
* | --- |
* | "Local Pick Up (No Tracking Required)" |
*
* @param {Samples_Local_Pickup_No_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_local_pickup_no_tracking = /** @type {((inputs?: Samples_Local_Pickup_No_TrackingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Local_Pickup_No_TrackingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_local_pickup_no_tracking(inputs)
	return es_samples_local_pickup_no_tracking(inputs)
});